import { LazyImport, LazyModule } from 'owa-bundling';

export { default as addAccount } from './actions/addAccount';
export { default as setLoadState } from './actions/setLoadState';
export { default as onSelectedAccountChanged } from './actions/onSelectedAccountChange';
export { default as getAccountBySourceId } from './selectors/getAccountBySourceId';
export { default as getSelectedAccount } from './selectors/getSelectedAccount';
export { default as getStoreLoadingState } from './selectors/getStoreLoadingState';
export { default as getAccountSourceListStore } from './store/accountSourceListStore';
export {
    AccountSourceType,
    LoadState,
    M365AuthProvider,
    MailboxType,
} from './store/schema/AccountSourceList';
export type {
    AccountSource,
    AccountSourceList,
    Characteristics,
    M365Mailbox,
} from './store/schema/AccountSourceList';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "SourceListStoreActions"*/ './lazyIndex')
);

// Register mutators
import './mutators/addAccountMutator';
import './mutators/setLoadStateMutator';

export const lazyRemoveAccountById = new LazyImport(lazyModule, m => m.removeAccountById);
export const lazySetSelectedAccount = new LazyImport(lazyModule, m => m.setSelectedAccount);
